import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo11 } from "../../../routes/Module11";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Imagen1 from "../../../images/modulo11/comic1.png";
import Imagen2 from "../../../images/modulo11/comic2.png";
import Imagen3 from "../../../images/modulo11/comic3.png";

import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo11/Actividad 11.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo11.content[0];
  const infoAct = modulo11.content[0].activities[10];
  const crumbs = [
    {
      title: modulo11.title,
      url: "/" + modulo11.url,
    },
    {
      title:
        modulo11.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo11.content[0].activities[9].name}`,
    linkPrev: `${modulo11.url}/${modulo11.content[0].path}/${modulo11.content[0].activities[9].path}`,
  };
  const metadata = {
    color: modulo11.color,
    title: `${modulo11.title} - ${infoAct.name}`,
    name: modulo11.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo11.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-4">
        <li>
          Imagina un caso en el que dos personas han cometido un delito y van a
          ser juzgadas.
        </li>
        <li>Completa el diálogo en la siguiente historieta.</li>
      </ul>
      <div
        className="row mt-10 px-md-5 bg-comic"
        style={{ backgroundImage: `url(${Imagen1})` }}
      >
        <div className="col-4">
          <textarea className="form-control mt-5" rows={3} />
        </div>
        <div className="col-8"></div>
      </div>
      <div
        className="row mt-10 px-md-5 bg-comic"
        style={{ backgroundImage: `url(${Imagen2})` }}
      >
        <div className="col-6"></div>
        <div className="col-6">
          <textarea className="form-control mt-5" rows={4} />
        </div>
      </div>
      <div
        className="row mt-10 px-md-5 bg-comic"
        style={{ backgroundImage: `url(${Imagen3})` }}
      >
        <div className="col-4">
          <textarea className="form-control mt-5" rows={4} />
        </div>
        <div className="col-4"></div>
        <div className="col-4">
          <textarea className="form-control mt-5" rows={4} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y observen las imágenes. Explique que elaborarán
          una historieta en 3 escenas. Para ello llenarán los globos de los
          personajes con textos que indiquen lo siguiente: en la primera escena,
          el policía anuncia el delito de los delincuentes; en la segunda
          escena, el juez dice la sentencia; en la tercera escena, los
          delincuentes se arrepienten.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo12.url}>
          <button className={`btn btn-${modulo11.color} me-2`}>
            {modulo12.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Actividad9;
